import EnumClass, { build } from '../EnumClass';
import data, { BibliographyTypeId, BibliographyTypeData } from './data';
import * as Translations from './translations';

export class BibliographyType extends EnumClass<BibliographyTypeId, BibliographyTypeData> {
  public get getName() {
    return Translations.name[this.id];
  }
}

export const {
  list: BIBLIOGRAPHY_TYPES,
  getById: getBibliographyTypeById,
  marshaller: BibliographyTypeMarshaller,
  codec: BibliographyTypeCodec,
} = build<BibliographyTypeId, BibliographyTypeData, BibliographyType>('BibliographyTypeEnum', data, BibliographyType);
